import { Controller } from '@hotwired/stimulus';

// Opens a shared modal and fills it from a <template> referenced by the button.
export default class extends Controller {
  static targets = ['modal', 'body'];

  open(event) {
    event.preventDefault();
    const templateId = event.currentTarget.getAttribute('data-details-modal-template-param');
    const template = templateId && document.getElementById(templateId);
    if (!template || !this.hasBodyTarget) return;

    this.bodyTarget.innerHTML = template.innerHTML;
    this.modalTarget.style.display = 'flex';
  }

  close(event) {
    if (event) event.preventDefault();
    this.modalTarget.style.display = 'none';
    if (this.hasBodyTarget) this.bodyTarget.innerHTML = '';
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close(event);
  }

  closeOnEscape(event) {
    if (event.key === 'Escape' && this.modalTarget.style.display === 'flex') {
      this.close(event);
    }
  }
}
